// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J6WS","right":"styles_right__uVoZF"};